var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"inline-block text-xs font-bold bg-gray-default text-white mr-1 px-1 lg:px-2 lg:py-0.5 rounded-sm",domProps:{"innerHTML":_vm._s(("" + _vm.text))}})}
var staticRenderFns = []

export { render, staticRenderFns }